// extracted by mini-css-extract-plugin
export default {"container":"_891Yz","participantInfo":"eBJY5","nameContainer":"PaUMA","name":"r83n5","label":"vaLVp","reaction":"kEj-z","mic":"hFDVL","icons":"_5B85b"};